// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import {
  ChakraProvider,
  ColorModeScript,
  extendTheme,
} from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource-variable/fraunces';
import '@fontsource/work-sans';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';

// Claro por defecto; el botón sol/luna cambia a oscuro (se recuerda en el navegador).
const config = { initialColorMode: 'light', useSystemColorMode: false };

const theme = extendTheme({
  config,
  fonts: {
    heading: `'Fraunces Variable', serif`,
    body: `'Work Sans', system-ui, sans-serif`,
  },
  colors: {
    brand: {
      50: '#EEF4FF',
      100: '#DAE6FF',
      200: '#BCD2FF',
      300: '#8EB4FF',
      400: '#5B8DF6',
      500: '#2F66E0',
      600: '#2453BF',
      700: '#1E4399',
      800: '#1B3876',
      900: '#172C57',
    },
  },
  semanticTokens: {
    colors: {
      bg:         { default: '#FAFAF8', _dark: '#0B1220' },
      panel:      { default: '#FFFFFF', _dark: '#111A2C' },
      ink:        { default: '#1A1D23', _dark: '#E6EAF2' },
      inkDim:     { default: '#5B6270', _dark: '#99A5B8' },
      border:     { default: '#E6E8EC', _dark: '#1F2B40' },
      accent:     { default: '#2F66E0', _dark: '#7CA8FF' },
      accentSoft: { default: '#EEF3FE', _dark: 'rgba(124,168,255,0.12)' },
    },
  },
  styles: {
    global: {
      html: { scrollBehavior: 'smooth' },
      body: { bg: 'bg', color: 'ink', WebkitFontSmoothing: 'antialiased', transition: 'background .2s' },
      '::selection': { bg: 'accentSoft' },
    },
  },
  components: {
    Input: { defaultProps: { focusBorderColor: 'accent' } },
    Textarea: { defaultProps: { focusBorderColor: 'accent' } },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={config.initialColorMode} />
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </HelmetProvider>
  </React.StrictMode>
);
